import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsIconModule,
    CmpsPortalModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../../route.module';
import { CmpsCardModule } from '../card';
import { ExperimentalNgGridModule } from '../grid';
import { CmpsTextFilterModule } from '../text-filter';

import { LandingComponent } from './landing.component';
import { TranslationIdMap } from './landing.i18n';
import { LandingRoutes } from './landing.route';

@NgModule({
    declarations: [LandingComponent],
    exports: [LandingComponent],
    imports: [
        CmpsButtonGroupModule,
        CmpsButtonModule,
        CmpsCardModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsLazyRouterModule.forChild(LandingRoutes),
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsPortalModule,
        CmpsTextFilterModule,
        CommonModule,
        ExperimentalNgGridModule,
        FormsModule,
    ],
})
export class CmpsEvalLandingModule {}
